// Due-date helpers. Due dates are saved as calendar days ("YYYY-MM-DD"); "today" is Eastern (America/New_York).
// Never parse "YYYY-MM-DD" with new Date(str): that is UTC midnight and shows the day BEFORE in Eastern time.
const TZ = 'America/New_York';
export const todayET = (now = new Date()) => new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
export const dayKey = (v) => {
  if (!v) return '';
  if (typeof v === 'number' || v instanceof Date) { const d = new Date(v); return isNaN(d) ? '' : todayET(d); }
  const s = String(v);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const d = new Date(s); return isNaN(d) ? '' : todayET(d);
};
export const isOverdueDue = (dueDate, status, now = new Date()) => {
  if (status === 'completed' || status === 'na') return false;
  const k = dayKey(dueDate); return !!k && k < todayET(now);
};
export const formatDue = (v, opts = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  const k = dayKey(v); if (!k) return v ? String(v) : '';
  const [y, m, d] = k.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d, 12)).toLocaleDateString('en-US', { ...opts, timeZone: 'UTC' });
};
export const OVERDUE_RED = '#D64545';
